import CallError from '../../utils/CallError';
import { getBadParams, getMissingKeys } from '../../utils/general';
import { settings } from './setup';

/**
 * Gets the ECAPPS for a specific org
 * @param {object} params - an object of params
 * @param {string} params.accessToken - User IMS token
 * @param {string} params.appId - Id of the app
 * @param {string} params.versionId - Version of the app
 */
export default async (params = {}, signal = null) => {
  const requiredParams = ['source', 'appId', 'versionId', 'accessToken'];
  const paramsRules = {
    source: { allowedTypes: ['string'] },
    appId: { allowedTypes: ['string'] },
    versionId: { allowedTypes: ['string'] },
    accessToken: { allowedTypes: ['string'] },
  };
  const missingParams = getMissingKeys(params, requiredParams);
  let badParams = [];
  if (Object.keys(params).length) {
    badParams = getBadParams(params, paramsRules);
  }
  if (missingParams.length || badParams.length) {
    throw new CallError('params', null, 404, { missingParams, badParams });
  }
  const response = await fetch(
    `${settings.endpoint}/v1/createFreeEntitlements?appId=${params.appId}&appVersionId=${params.versionId}&sourceVal=${params.source}`,
    {
      signal,
      method: 'POST',
      headers: { Authorization: params.accessToken, 'Content-type': 'application/json', 'x-api-key': settings.apiKey },
    }
  );
  let content = await response.text();
  try {
    content = JSON.parse(content);
  } catch (e) {
    // response is not json
  }

  if (!response.ok) {
    throw new CallError('http', content, response.status, { message: response.statusText });
  } else {
    return content;
  }
};
